import { ITelemetryItem } from '@microsoft/applicationinsights-web';
import { getCorrelationId } from './correlationId';

// correlationId is a UUID (dashes included) in the common case, so stripping
// non-hex characters lines it up with the 32-char lowercase hex format
// Application Insights expects for ai.operation.id.
const toOperationId = (id: string): string => {
  const hex = id.toLowerCase().replace(/[^0-9a-f]/g, '');
  return hex.length >= 32 ? hex.slice(0, 32) : hex.padEnd(32, '0');
};

/**
 * Overrides the SDK's own per-page-view Operation ID with one derived from
 * the same x-correlation-id sent to the backend (see useAxios.ts), so the
 * Portal's End-to-end transaction view groups frontend and backend telemetry
 * together without relying on W3C traceparent headers. Requires the backend
 * to set its own request telemetry's Operation ID from x-correlation-id
 * using this same conversion.
 *
 * Also stamps the raw, dashed correlationId as its own custom property —
 * separate from the hex-stripped Operation ID above — because that's the
 * exact string testers copy from the browser's x-correlation-id request
 * header. Without it, pasting that dashed value into Portal Search matches
 * nothing (Operation ID is stored hex-only), which is exactly what a plain
 * ai.operation.id override alone doesn't cover.
 */
export const setOperationIdFromCorrelation = (item: ITelemetryItem): boolean => {
  const correlationId = getCorrelationId();
  item.data = { ...item.data, correlationId };
  item.tags = { ...item.tags, 'ai.operation.id': toOperationId(correlationId) };
  return true;
};
